import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=3f70011c&scoped=true&"
import script from "./StarRating.vue?vue&type=script&lang=ts&"
export * from "./StarRating.vue?vue&type=script&lang=ts&"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=3f70011c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70011c",
  null
  
)

export default component.exports